import React from 'react';
import clsx from 'clsx';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { TOAST_TYPES, TOAST_COLOR } from '@shared/constants';
import CloseIcon from '@assets/icons/cross-white.svg';
import ErrorIcon from '@assets/icons/error-symbol.svg';
import SuccessIcon from '@assets/icons/check-circle.svg';
import WarningIcon from '@assets/icons/warning.svg';
import InfoIcon from '@assets/icons/info.svg';
import useStyles from './style';

let oldMessages = [];
const DEFAULT_TOAST_CONFIG = {
  autoClose: 5000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  onClose: props => {
    oldMessages.splice(oldMessages.indexOf(props.message), 1);
  },
  draggable: true,
  closeButton: <React.Fragment />,
};

const BaseToast = ({ backgroundColor, message, type }) => {
  const classes = useStyles({
    backgroundColor,
  });

  return (
    <div
      className={clsx(classes.box, 'd-inline-flex', 'f-align-center')}
      data-testid='toast-base'
    >
      <img
        src={
          type === TOAST_TYPES.SUCCESS
            ? SuccessIcon
            : type === TOAST_TYPES.ERROR
            ? ErrorIcon
            : type === TOAST_TYPES.WARNING
            ? WarningIcon
            : InfoIcon
        }
        alt=''
        className={classes.icon}
      />
      <h3 className={clsx(classes.message, 'align-left')}>{message}</h3>
      <img
        src={CloseIcon}
        alt=''
        className={classes.icon}
        data-testid='toast-close-icon'
      />
    </div>
  );
};

const showToast = async (message, type = TOAST_TYPES.INFO, config) => {
  if (!message) {
    return;
  }

  const toastConfig = { ...DEFAULT_TOAST_CONFIG, ...config };
  if (oldMessages.includes(message)) {
    return null;
  } else {
    oldMessages.push(message);
  }

  const finalToast = (
    <BaseToast
      backgroundColor={TOAST_COLOR[type]}
      message={message}
      type={type}
    />
  );
  toast(finalToast, toastConfig);
};

export default showToast;
